module.exports = __webpack_public_path__ + "4e5e03d1124d4a685aa17ad5cb68af2a.jpg";